<template>
  <div class=" appbg">
  <div class="ms-login  ">
    <h1 class="ms-title">
      楚地恒大成控系统
    </h1>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="login-form">
      <el-form-item prop="username">
        <el-input v-model.trim="ruleForm.username" placeholder="用户名"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" placeholder="密码" v-model="ruleForm.password"></el-input>
      </el-form-item>

        <el-form-item prop="dbid">
            <el-select v-model="ruleForm.dbid"  placeholder="请选择公司">
                <el-option
                        v-for="item in dbidData"
                        :key="item.value"
                        :label="item.valueName"
                        :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>


      <el-row :gutter="15">
        <el-col :span="16">
          <el-form-item prop="verificaCode">
            <el-input @keyup.enter.native="submitForm('ruleForm')" v-model="ruleForm.verificaCode" placeholder="验证码"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8"><p class="verifica-code-img" @click="replaceCode()">{{initverificaCode}}</p></el-col>
      </el-row>
      <div class="save-password">
        <el-checkbox class="check-box" v-model="savePassword">记住密码</el-checkbox>
        <router-link  style=" font-size: 14px;" class="forgot-password" to="/resetPassword">忘记密码？</router-link>
      </div>
      <div class="login-btn">
        <el-button  type="primary" @click="submitForm('ruleForm')">登&nbsp;&nbsp;录</el-button>

      </div>

    </el-form>
  </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import loginJs from './login.js';
  export default loginJs
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>

  @import "../../common/css/common.styl";

  .ms-title
    text-align: center;
    font-size: 30px;
    margin-bottom 30px
    img
      width 158px
      height 20px
  .ms-login
    position: absolute;
    left: 50%;
    top: 50%;
    width: 320px;
    margin: -200px 0 0 -189px;
    padding: 50px 40px 40px
    border-radius: 5px;
    box-shadow 0 0 100px 0 rgba(0, 0, 0, 0.08)

  .login-form
    .el-form-item
      margin-bottom 20px
    .verifica-code-img
      width 100%
      height 28px
      line-height 28px
      margin-right 10px
      position relative
      top 5px
      text-align center
      background-color #eee
    .login-btn
      text-align: center;
    .login-btn button
      width: 100%;
      height: 36px;

    .ms-login p
      font-size: 12px;
      line-height: 30px;
      color: #999;
    .save-password
      display flex
      align-items center
      margin-bottom 10px
      .forgot-password
        margin-left 10px
      .check-box
        margin 0
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue